import { BlocksIconCheck } from 'blocks-nextjs/blocks-web-components/components/icon/icons/check';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCheck = createComponent({ react: React, tagName: 'cat-icon-check', elementClass: BlocksIconCheck });
